import { Box, Typography } from "@mui/material";
import { sessionLogo } from "./imagesStyles";
import emCircle from "./emCircle.png";

const SessionLogo = () => {
  return (
    <Box sx={(theme) => sessionLogo(theme)}>
      <Box mr={2}>
        <img src={emCircle} alt="" width="100" height="100" />
      </Box>
      <Typography variant="h2">Empower</Typography>
    </Box>
  );
};

export default SessionLogo;
